const styles = (theme) => ({
    usersByCountry: {
        width: '49.5%'
    },
    sales: {
        width: '100%'
    },
    analysis: {
        height: '420px'
    },
    wrap: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    analytics: {
        width: '100%'
    },
    statistics: {
        width: '64.5%',
        display: 'flex',
        flexWrap: 'wrap',
        overflowY: 'auto',
        gap: '10px'
    },
    salesByDeliveryType: {
        width: '34.5%'
    },
    
    

    item: {
        width: '24%',
        background: '#edf0f4',
        //padding: '10px',
        padding: '0.5rem 1rem',
        marginTop: '10px',
        marginRight: '1%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexDirection: 'column'
    },
    value: {
        fontSize: '16px'
    },
    statisticRoot: {
        padding: '0 16px 16px'
    },
    section1: {
        width: '100%',
        display: 'flex',
        // maxHeight: '420px',
        justifyContent: 'space-between'
    },
    section2: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px'
    },
    section3: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px'
    },
    // "@media (max-width: 1199px)": {
    //     wrap: {
    //         display: 'block',
    //         flexWrap: 'wrap'
    //     },
    //     section1: {
    //         display: 'flex',
    //         // maxHeight: '420px',
    //         // justifyContent: 'space-between'
    //     },
    // },

    
    "@media (max-width: 1199px)": {
        statistics: {
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            overflowY: 'auto',
            gap: '10px',
            marginBottom: '10px'
        },
        salesByDeliveryType: {
            width: '100%'
        },
        section1: {
            width: '100%',
            display: 'block',
        },
        item: {
            width: '49%',
        },
    },
});

export default styles;
